import {useEffect, useState} from "react";

export default function useScreenSize(min = 0, max = 1280, config={
    shouldUpdate:true,
    selector:undefined,
    attribute:undefined,
}) {
    const [inRange, setInRange] = useState(false);
    const [screenSize,setScreenSize] = useState(undefined);
    const {shouldUpdate,attribute,selector} = config;

    useEffect(() => {
        if (typeof window !== "undefined") {
            let element = selector ? document.querySelector(selector) : window;
            let eleAttribute = attribute ? attribute : "innerWidth";
            let updater = () => {
                setScreenSize(element[eleAttribute]);
                let largerThanMin = screenSize > min;
                let smallThanMax = screenSize < max;
                if (largerThanMin && smallThanMax) {
                    setInRange(true)
                } else if (!largerThanMin || !smallThanMax) {
                    setInRange(false)
                }
            }
            updater();
            if (shouldUpdate) {
                window.addEventListener("resize", updater);
                return () => window.removeEventListener("resize", updater);
            }
        }
    },[inRange,screenSize,config,min,max,shouldUpdate,selector,attribute]);
    return [inRange,screenSize]
}